import { defineMessages } from 'react-intl'

/** Car hire highlights tab labels and informational copy. */
const carHireGlossaryMessages = defineMessages({
  refundableSecurityDeposit: {
    id: 'wt1SfDTYXzrAiu8K5ISP',
    defaultMessage: 'Refundable Security Deposit',
    description: 'Label for the refundable security deposit in car hire highlights tab',
  },
  damageAndTheftExcess: {
    id: 'BT8d0g241HVJomDCxa_s',
    defaultMessage: 'Damage & Theft Excess',
    description: 'Label for the damage and theft excess in car hire highlights tab',
  },
  viewMore: {
    id: 'KsW-MUEYz_QMjvCX0Cas',
    defaultMessage: 'View more',
    description: 'Link to navigate to a details tab in car hire highlights',
  },
  noHighlightsInfo: {
    id: 'xrV7vQHehw8b8R7Ic4yk',
    defaultMessage: 'No highlights information available for this vehicle.',
    description: 'Message shown when no highlights data is available in car hire highlights tab',
  },
})

export default carHireGlossaryMessages
